import httpClient from '../httpClient';

export const getCareerConfig = async () => {
  const result = await httpClient.get('/career/config');
  return result.data;
};

export const submitCareerApplication = async (formData) => {
  const result = await httpClient.post('/career', formData);
  return result.data;
};
